(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[539],{

/***/ 25208:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(67294));
var _router = __webpack_require__(62887);
var _router1 = __webpack_require__(30165);
var _useIntersection = __webpack_require__(93927);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    router.prefetch(href, as, options).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    // replace state instead of push if prop is present
    router[replace ? "replace" : "push"](href, as, {
        shallow: shallow,
        locale: locale,
        scroll: scroll
    });
}
var Link = /*#__PURE__*/ _react.default.forwardRef(function(props, forwardedRef) {
    var _legacyBehavior = props.legacyBehavior, legacyBehavior = _legacyBehavior === void 0 ? Boolean(false) !== true : _legacyBehavior;
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var children;
    var hrefProp = props.href, asProp = props.as, childrenProp = props.children, prefetchProp = props.prefetch, passHref = props.passHref, replace = props.replace, shallow = props.shallow, scroll = props.scroll, locale = props.locale, onClick = props.onClick, onMouseEnter = props.onMouseEnter, restProps = _objectWithoutProperties(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter"
    ]);
    children = childrenProp;
    if (legacyBehavior && typeof children === "string") {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    var p = prefetchProp !== false;
    var router = (0, _router1).useRouter();
    var ref2 = _react.default.useMemo(function() {
        var ref = _slicedToArray((0, _router).resolveHref(router, hrefProp, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]), href = ref2.href, as = ref2.as;
    var previousHref = _react.default.useRef(href);
    var previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    }
    var childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootMargin: "200px"
    }), 3), setIntersectionRef = ref1[0], isVisible = ref1[1], resetVisible = ref1[2];
    var setRef = _react.default.useCallback(function(el) {
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        var isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale);
            }
        },
        onMouseEnter: function(e) {
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            if ((0, _router).isLocalURL(href)) {
                prefetch(router, href, as, {
                    priority: true
                });
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        var curLocale1 = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _router).getDomainLocale(as, curLocale1, router && router.locales, router && router.domainLocales);
        childProps.href = localeDomain || (0, _router).addBasePath((0, _router).addLocale(as, curLocale1, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if (typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) {
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 98581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ CartMenuV2; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-app-events/lib/index.js
var lib = __webpack_require__(5275);
// EXTERNAL MODULE: ./src/components/Address/index.tsx + 11 modules
var Address = __webpack_require__(21916);
// EXTERNAL MODULE: ./src/helpers/events/index.ts
var events = __webpack_require__(52860);
// EXTERNAL MODULE: ./src/hooks/useEffect.ts
var useEffect = __webpack_require__(10338);
// EXTERNAL MODULE: ./src/hooks/useShouldUseNewAddressesUI.ts
var useShouldUseNewAddressesUI = __webpack_require__(17664);
// EXTERNAL MODULE: ./src/hooks/useState.ts
var useState = __webpack_require__(48249);
// EXTERNAL MODULE: ./src/page-components/Order/Cart/Content/index.tsx + 10 modules
var Content = __webpack_require__(87336);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 50 modules
var esm = __webpack_require__(32533);
// EXTERNAL MODULE: ./src/page-components/Order/Options/UpdateBasicOptions/index.tsx + 1 modules
var UpdateBasicOptions = __webpack_require__(82096);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./src/components/ClickOutside/index.tsx
var ClickOutside = __webpack_require__(98816);
// EXTERNAL MODULE: ./src/helpers/misc/sleep.ts
var sleep = __webpack_require__(77712);
// EXTERNAL MODULE: ./src/i18n/formatNumber/Component.tsx
var Component = __webpack_require__(18085);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/Container/index.js
var Container = __webpack_require__(59848);
// EXTERNAL MODULE: ./src/page-components/Order/CartMenuV2/CartMenu/styles.module.css
var styles_module = __webpack_require__(7529);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/CartMenuV2/CartMenu/index.tsx
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}










var CartMenu = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(CartMenu, _Component);
    var _super = _createSuper(CartMenu);
    function CartMenu() {
        _classCallCheck(this, CartMenu);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            className: "",
            showMessage: "close"
        };
        return _this;
    }
    var _proto = CartMenu.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var cart = this.props.cart;
        var total = cart && cart.totalPrice || 0;
        if (total) {
            this.showMessage();
        }
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        var cart = this.props.cart;
        var prevCart = prevProps.cart;
        if (!prevCart) return; // First load, skip animation
        var total = cart && cart.totalPrice || 0;
        var prevTotal = prevCart && prevCart.totalPrice || 0;
        if (total > prevTotal) {
            this.attention();
        }
        if (!prevTotal && total) {
            this.showMessage();
        }
    };
    _proto.attention = function attention() {
        var _this = this;
        return _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _this.setState({
                            className: "animated shake"
                        });
                        _ctx.next = 3;
                        return (0,sleep/* default */.Z)(1000);
                    case 3:
                        _this.setState({
                            className: "animated"
                        });
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.showMessage = function showMessage() {
        var _this = this;
        return _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _this.setState({
                            showMessage: "show"
                        });
                        _ctx.next = 3;
                        return (0,sleep/* default */.Z)(3000);
                    case 3:
                        _this.setState({
                            showMessage: "hide"
                        });
                        _ctx.next = 6;
                        return (0,sleep/* default */.Z)(1000);
                    case 6:
                        _this.setState({
                            showMessage: "close"
                        });
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.render = function render() {
        var _props = this.props, open = _props.open, onClick = _props.onClick, cart = _props.cart, setOpenOptions = _props.setOpenOptions, openOptions = _props.openOptions, optionsLabel = _props.optionsLabel;
        var total = cart && cart.itemsPrice || 0;
        var openClassName = total > 0 ? (styles_module_default()).cartHightlightMobile : "";
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: openClassName + " " + (styles_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (styles_module_default()).inner,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: cart ? (styles_module_default()).addressCallToAction : (styles_module_default()).addressCallToActionLoading,
                                onClick: openOptions ? null : setOpenOptions,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (styles_module_default()).title,
                                        children: optionsLabel
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (styles_module_default()).icon,
                                        children: openOptions ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdKeyboardArrowUp */.rWj, {
                                            size: 22
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdKeyboardArrowDown */.Ix0, {
                                            size: 22
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default()).divider,
                                onClick: open ? null : onClick
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (styles_module_default()).button,
                                onClick: open ? null : onClick,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (styles_module_default()).total + " " + this.state.className,
                                        children: cart ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Component/* default */.Z, {
                                            value: total
                                        }) : ""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (styles_module_default()).icon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdShoppingBasket */.Kvb, {
                                            size: 22,
                                            style: {
                                                marginRight: 5
                                            },
                                            "aria-label": "cart"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                this.state.showMessage !== "close" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).childrenContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: this.state.showMessage === "show" ? (styles_module_default()).message : (styles_module_default()).messageHide,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (styles_module_default()).arrowWrapper,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (styles_module_default()).arrowUp
                                    })
                                }),
                                this.props.t("order.titleOrderContinue")
                            ]
                        })
                    })
                }) : null,
                openOptions ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickOutside/* default */.Z, {
                        onClickOutside: setOpenOptions,
                        avoidElementName: "modal-root",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (styles_module_default()).childrenContainer,
                            children: this.props.options
                        })
                    })
                }) : null,
                open ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickOutside/* default */.Z, {
                        onClickOutside: onClick,
                        avoidElementName: "modal-root",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (styles_module_default()).childrenContainer,
                            children: this.props.children
                        })
                    })
                }) : null
            ]
        });
    };
    return CartMenu;
}(react.Component);
/* harmony default export */ var CartMenuV2_CartMenu = ((0,esm/* withTranslation */.Zh)()(CartMenu));

// EXTERNAL MODULE: ./src/page-components/Order/CartMenuV2/OptionsLabel/styles.module.css
var OptionsLabel_styles_module = __webpack_require__(64321);
var OptionsLabel_styles_module_default = /*#__PURE__*/__webpack_require__.n(OptionsLabel_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/CartMenuV2/OptionsLabel/index.tsx




function OptionsLabel(props) {
    var preferences = props.preferences;
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "order.cartMenuV2.optionsLabel"
    }).t;
    if (!preferences.cart) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (OptionsLabel_styles_module_default()).loading
    });
    if (preferences.deliveryType === "delivery") {
        if (preferences.address) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (OptionsLabel_styles_module_default()).container,
                children: preferences.address.address
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (OptionsLabel_styles_module_default()).container,
                children: t("address")
            });
        }
    }
    if (!preferences.store) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (OptionsLabel_styles_module_default()).container,
            children: t("store")
        });
    }
    if (preferences.deliveryType === "go") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (OptionsLabel_styles_module_default()).container,
            children: t("storeGo", {
                store: preferences.store.name
            })
        });
    }
    var label = preferences.tableName ? t("labelTable", {
        table: preferences.tableName
    }) : t("labelServe");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (OptionsLabel_styles_module_default()).container,
        children: [
            preferences.store.name,
            ", ",
            label
        ]
    });
};

// EXTERNAL MODULE: ./src/page-components/Order/CartMenuV2/Skeleton.tsx
var Skeleton = __webpack_require__(27457);
// EXTERNAL MODULE: ./src/page-components/Order/CartMenuV2/styles.module.css
var CartMenuV2_styles_module = __webpack_require__(66951);
var CartMenuV2_styles_module_default = /*#__PURE__*/__webpack_require__.n(CartMenuV2_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/CartMenuV2/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function CartMenuV2_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function CartMenuV2_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                CartMenuV2_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                CartMenuV2_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
















function CartMenuV2(props) {
    var preferences = props.preferences, website = props.website, layout = props.layout, loading = props.loading;
    var ref = _slicedToArray((0,useState/* useState */.e)(false), 2), open = ref[0], setOpen = ref[1];
    var ref1 = _slicedToArray((0,useState/* useState */.e)(false), 2), openOptions = ref1[0], setOpenOptions = ref1[1];
    var ref2 = _slicedToArray((0,useState/* useState */.e)(false), 2), hiddenPrice = ref2[0], setHiddenPrice = ref2[1];
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "order"
    }).t;
    var shouldUseNewAddressesUI = (0,useShouldUseNewAddressesUI/* default */.Z)();
    (0,useEffect/* useEffect */.d)(function() {
        if (!loading && !preferences.store) {
            setOpenOptions(true);
        }
    }, [
        loading
    ]);
    (0,useEffect/* useEffect */.d)(function() {
        setHiddenPrice(false);
    }, [
        preferences
    ]);
    (0,lib/* useOnEvent */.dh)("hiddenPriceProductOpened", CartMenuV2_asyncToGenerator(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    setOpenOptions(true);
                    setHiddenPrice(true);
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })));
    var shouldShowOptions = !preferences.store;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartMenuV2_CartMenu, {
            open: open,
            openOptions: openOptions,
            onClick: function() {
                (0,events.sendEvent)(events.EVENTS.clicked.cart, {
                    open: !open
                });
                if (shouldShowOptions) setTimeout(function() {
                    return setOpenOptions(!openOptions);
                });
                else setTimeout(function() {
                    return setOpen(!open);
                });
            },
            setOpenOptions: function() {
                setTimeout(function() {
                    return setOpenOptions(!openOptions);
                });
            },
            cart: preferences.cart,
            optionsLabel: /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionsLabel, {
                preferences: preferences
            }),
            options: shouldUseNewAddressesUI ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Address["default"], {
                closeModal: function() {
                    return setOpenOptions(false);
                }
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((CartMenuV2_styles_module_default()).options, " ").concat(hiddenPrice ? (CartMenuV2_styles_module_default()).hiddenPrice : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CartMenuV2_styles_module_default()).title,
                        children: t("cartMenuV2.labelOptionsTitle")
                    }),
                    hiddenPrice ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: t("cartMenuV2.addressNeeded")
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CartMenuV2_styles_module_default()).optionsContent,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UpdateBasicOptions/* default */.Z, {
                            preferences: preferences
                        })
                    })
                ]
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CartMenuV2_styles_module_default()).container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CartMenuV2_styles_module_default()).title,
                        children: t("titleMyOrder")
                    }),
                    preferences.cart ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Content/* default */.Z, {
                        preferences: preferences,
                        website: website,
                        layout: layout
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {})
                ]
            })
        })
    });
};


/***/ }),

/***/ 7529:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_1bQ5DFEYpfetSmZY06QX7W backgroundBorderColor backgroundColor","button":"_1YZIoj0th_6B7NOJHPgL0_","addressCallToAction":"_2-HEcOI_-KKoBR6_kWIHwU _1YZIoj0th_6B7NOJHPgL0_ content primaryColor","addressCallToActionLoading":"F1j_VtgM8l06nrjKMhtbl _2-HEcOI_-KKoBR6_kWIHwU _1YZIoj0th_6B7NOJHPgL0_ content primaryColor","cartHightlightMobile":"_3OKG7QGPuwrnP8HcRDEN6l primaryBackgroundColor","flexItem":"_2C5OcTKuKGzLDF0SY2idub","inner":"Arpt_A3C3Jqu4n8qKcRTU _2C5OcTKuKGzLDF0SY2idub","title":"NkpkcUlswOOQ1gcvIyXPS _2C5OcTKuKGzLDF0SY2idub","total":"_1pgIPVynlf65eNmAgXJdK3 _2C5OcTKuKGzLDF0SY2idub","icon":"_2aeynOSTINZBPvOudeAcwh _2C5OcTKuKGzLDF0SY2idub","divider":"_3bPyKNZRxckttv9Lf_Tezl","message":"_3BxWMCaudCrhqO5zJAJhBR animated fadeIn","messageHide":"_2hhkOOXln9z6sSMDMrqWFh _3BxWMCaudCrhqO5zJAJhBR animated fadeIn fadeOut","arrowWrapper":"yh_CiHZ4JDSs1_z97wUH8","arrowUp":"_3-vwCg87NFXhvMKLx4Wr6O","childrenContainer":"Y5USBMwC-qBEXwm6ZWyby"};

/***/ }),

/***/ 64321:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_25TFeypo-VC6x_SRlhBUCq","loading":"_3oTnjcuokOSL6m44hTNfcL loadingGlow"};

/***/ }),

/***/ 41664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(25208)


/***/ })

}]);